/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/controls/modalContextController.ts" />

module Meevo.Plugins.Tax {
    class TaxAuditLogController extends Meevo.Components.Controls.ModalContextController {
        auditDataHistory: any;
        taxId: Meevo.Guid;
        pageNumber: number;
        startDateTime: any;
        endDateTime:any;
        static $inject = ["meevo.AppSettings",
            "meevo.components.common.BusinessInfoDataService", "$mdDialog", "taxId", "pageNumber", "startDateTime","endDateTime"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.Common.BusinessInfoDataService,
            protected $mdDialog: angular.material.IDialogService,
            taxId: Meevo.Guid,
            pageNumber: number,
            startDateTime?: any,
            endDateTime?: any) {
           
            super(null, $mdDialog);
            this.taxId = taxId;
            this.pageNumber = pageNumber;
            this.startDateTime = startDateTime;
            this.endDateTime = endDateTime;
            this.viewSearchedAuditHistory(taxId, pageNumber, startDateTime, endDateTime);

        }

        searchAudit = (taxId: Guid, pageNumber:number, startDateTime?: any, endDateTime?:any) => {
            this.viewSearchedAuditHistory(taxId, pageNumber, startDateTime, endDateTime);
        }

        
        viewSearchedAuditHistory(taxId: Guid, pageNumber: number, startDateTime?: any, endDateTime?:any){
            var searchModel: any = {
                id: taxId,
                pageNumber: pageNumber,
                itemsPerPage: 25,
                startDateTime: startDateTime,
                endDateTime: endDateTime

            };
            if(taxId!=null)
                this.dataService.customMethodData("api/Tax/" + taxId + "/History", "POST", searchModel)
                .then((response) => {
                    if (response.data) {
                        this.auditDataHistory = response.data;

                        for (var i = 0; i < this.auditDataHistory.length; i++) {
                            this.auditDataHistory[i].json = JSON.parse(this.auditDataHistory[i].json);
                        }
                        
                        
                    }
                });
        }
        closeModal = () => {
            this.$mdDialog.cancel();
        }
    }

    angular.module("meevo.plugins.tax")
        .controller("meevo.plugins.tax.TaxAuditLogController", TaxAuditLogController);
}